import { httpInstance } from '../../api'
import * as types from '../mutation-types'

const state = {
  pendingPR: 0,
  pendingPO: 0,
  totalUser: 0,
  currentLoginUsers: []
}

const getters = {
  getPendingPR: state => state.pendingPR,
  getPendingPO: state => state.pendingPO,
  getTotalUser: state => state.totalUser,
  getCurrentLoginUsers: state => state.currentLoginUsers
}

const mutations = {
  [types.GET_PENDING_PR] (state, payload) {
    state.pendingPR = payload
  },

  [types.GET_PENDING_PO] (state, payload) {
    state.pendingPO = payload
  },

  [types.GET_TOTAL_USERS] (state, payload) {
    state.totalUser = payload
  },

  [types.GET_LOGIN_USERS] (state, payload) {
    state.currentLoginUsers = payload
  }
}

const actions = {
  async fetchPendingPR ({ commit }) {
    await httpInstance
      .get(`purchase/total-pr`)
      .then(response => {
        commit(types.GET_PENDING_PR, response.data)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
      })
  },

  async fetchPendingPO ({ commit }) {
    await httpInstance
      .get(`purchase/total-po`)
      .then(response => {
        commit(types.GET_PENDING_PO, response.data)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
      })
  },

  async fetchTotalUser ({ commit }) {
    await httpInstance
      .get(`auth/mibile-user/total`)
      .then(response => {
        commit(types.GET_TOTAL_USERS, response.data)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
      })
  },

  async fetchCurrentLoginUsers ({ commit }) {
    await httpInstance
      .get(`user/current-login/list`)
      .then(response => {
        commit(types.GET_LOGIN_USERS, response.data)
      })
      .catch(error => {
        console.log(error.response)
        commit(types.LOAD_RESPONSE, error.response)
      })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dashboard.js